/**
 * Scottish income tax is a HARD-GATED product boundary (Phase 1 scope), not a
 * toggle: the DB CHECK and the write contract already reject `scotland` at
 * fact-find entry, and this gate makes the tax layer refuse too, so a
 * Scottish taxpayer can never be silently mis-taxed with rUK bands. The
 * decision is documented in docs/tax/scottish-taxpayers.md.
 */
export class ScottishTaxpayerNotSupportedError extends Error {
    constructor() {
        // Client-visible wording rules (2026-08-26 quality review): no internal
        // roadmap vocabulary ("Phase 1"), no forward promise ("until X ships" —
        // reinstating a roadmap commitment is the owner's call, never a default),
        // and the refusal names the CALCULATION, not the person.
        super('Scottish income tax bands are not implemented in this tool, and rest-of-UK bands ' +
            'must never be applied to a Scottish taxpayer — so no projection can be produced ' +
            'while a person is marked as a Scottish taxpayer. Scottish support is outside the ' +
            'tool’s current scope.');
        this.name = 'ScottishTaxpayerNotSupportedError';
    }
}
/** Throws for any region whose bands this package does not implement. */
export function assertSupportedTaxRegion(region) {
    if (region !== 'rUK') {
        throw new ScottishTaxpayerNotSupportedError();
    }
}
//# sourceMappingURL=region.js.map